export default "__VITE_ASSET__BjD4uIuw__"